import { render, staticRenderFns } from "./LegendSelectorAntV.vue?vue&type=template&id=2db45648&scoped=true"
import script from "./LegendSelectorAntV.vue?vue&type=script&lang=js"
export * from "./LegendSelectorAntV.vue?vue&type=script&lang=js"
import style0 from "./LegendSelectorAntV.vue?vue&type=style&index=0&id=2db45648&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db45648",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db45648')) {
      api.createRecord('2db45648', component.options)
    } else {
      api.reload('2db45648', component.options)
    }
    module.hot.accept("./LegendSelectorAntV.vue?vue&type=template&id=2db45648&scoped=true", function () {
      api.rerender('2db45648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/componentStyle/LegendSelectorAntV.vue"
export default component.exports